import { Routes } from '@angular/router';
import { AuthenticatedGuard } from './core/guards/authenticated.guard';
import { AuthGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./shared/components/layout/layout.component'),
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./app-demo/app-demo.component'),
        canActivate: [AuthGuard],
      },
    ],
  },
  {
    path: 'login',
    loadComponent: () => import('./core/components/login/login.component'),
    canActivate: [AuthenticatedGuard],
  },
  {
    path: '**',
    redirectTo: '/',
  },
];
